import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Button, Modal, Input, DatePicker, notification, Typography,
} from "antd";
// import { AiOutlinePlus } from "react-icons/ai";
import {  useParams } from "react-router-dom";
import { getClientTasks, updateBill } from "../../../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";



import SearchBar from "../../../components/searchbar/SearchBar";




const ClientReportHome = () => {
  const [rows, setRows] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [billNumber, setBillNumber] = useState("");
  const [billDate, setBillDate] = useState(null);
  const { id } = useParams();

  const { clientTasks } = useSelector((state) => state.auth);

  const [inProgressCount, setInProgressCount] = useState(0);
  const [completedCount, setCompletedCount] = useState(0);

  const formData = new FormData();
  formData.append("id", id);




  useEffect(() => {
    const data = [
      {
        id: 1,
        taskId: "PBCTS1001",
        taskName: "Lorem ipsum",
        dueDate: "02/02/24",
        assignee: "Assignee Name",
        taskStatus: "Completed",
        billingStatus: "Not billed",
        billNumber: "",
        billDate: "",
      },
      {
        id: 2,
        taskId: "PBCTS1002",
        taskName: "Dolor sit amet",
        dueDate: "02/02/24",
        assignee: "Assignee Name",
        taskStatus: "Completed",
        billingStatus: "Not billed",
        billNumber: "",
        billDate: "",
      },
      // Add more rows as needed...
    ];
    setRows(data);
  }, []);


  useEffect(() => {
    if (clientTasks) {
      setRows(clientTasks);

      // Calculate counts
      const inProgress = clientTasks.filter(task => task.status === "Pending").length;
      const completed = clientTasks.filter(task => task.status === "Completed").length;

      setInProgressCount(inProgress);
      setCompletedCount(completed);
    }
  }, [clientTasks]);


  const handleSearch = (searchTerm) => {
    console.log("Search triggered:", searchTerm);

    const filteredRows = clientTasks.filter((r) =>
      r?.service?.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    console.log("Filtered rows:", filteredRows);
    setRows(filteredRows);
  };



  const dispatch = useDispatch();
  const token = localStorage.getItem("token");


  useEffect(() => {
    async function func() {
      try {
        if (token) {
          await dispatch(getClientTasks(id));
        }
      }
      catch (err) {
        console.log(err);
      }
    }
    func();
  }, [dispatch, id, token])

  useEffect(() => {
    if (clientTasks) {
      setRows(clientTasks)
    }
  }, [clientTasks])



  

  const handleRowClick = (params) => {
    const row = params.row;
  
    setSelectedRow(row);  // Store selected task for update
    setBillNumber(row.billNumber || "");
  
    // Handle bill date using native Date
    // if (row.billDate) {
    //   const parsedDate = new Date(row.billDate);
    //   if (!isNaN(parsedDate)) {
    //     setBillDate(parsedDate);  // Set as a Date object
    //   } else {
    //     setBillDate(null); // Handle invalid date
    //   }
    // } else {
    //   setBillDate(null); // No date in row
    // }
  
    setModalVisible(true);
  };
  
  



  const getStatusStyle = (status) => {
    switch (status) {
      case "Upcoming":
        return { color: "#0080ff", fontWeight: "bold" };
      case "Completed":
        return { color: "green", fontWeight: "bold" };
      case "In Progress":
        return { color: "orange", fontWeight: "bold" };
      case "Pending":
        return { color: "#ff6600", fontWeight: "bold" };
      default:
        return {};
    }
  };





  const handleSubmit = async () => {
    if (!billNumber || !billDate || !selectedRow) {
      return notification.error({
        message: "Error",
        description: "Bill Number and Date are required.",
      });
    }

    try {
      await dispatch(updateBill(selectedRow._id, {
        billNumber,
        billDate, // Format before sending
      }));

      notification.success({
        message: "Success",
        description: "Billing information updated.",
      });

      // Update local state
      const updated = rows.map(row =>
        row._id === selectedRow._id
          ? {
            ...row,
            billingStatus: true,
            billNumber,
            billDate,
          }
          : row
      );

      setRows(updated);
      setModalVisible(false);
      setBillNumber("");
      setBillDate("");
    } catch (error) {
      console.error("Update failed:", error);
      notification.error({
        message: "Error",
        description: "Failed to update bill.",
      });
    }
  };



  const columns = [
    { field: "id", headerName: "Task ID", width: 150 },
    {
      field: "service", headerName: "Task Name", width: 250,
      renderCell: (params) => {
        return params?.value?.name;
      }
    },
    {
      field: "dueDate", headerName: "Due Date", width: 150,
      renderCell: (params) => (
        <Typography
          style={{
            color: params.value === "02/02/24" ? "red" : "black",
            fontWeight: params.value === "02/02/24" ? "bold" : "normal",
          }}
        >
          {new Date(params.value).toDateString()}
        </Typography>
      ),
    },
    {
      field: "assignees", headerName: "Assignee", width: 200,
      renderCell: (params) =>
        params.value?.length
          ? params.value.map((a) => a.name).join(", ")
          : "—",
    },
    {
      field: "status", headerName: "Task Status", width: 150,
      renderCell: (params) => (
        <div style={getStatusStyle(params.value)}>{params.value}</div>
      ),
    },
    {
      field: "billingStatus",
      headerName: "Billing Status",
      width: 150,
      renderCell: (params) => (
        <span style={{ color: params.value === true ? "green" : "ff6600" }}>
          {params.value === true ? "Billed" : "Not Billed"}
        </span>
      ),
    },
    {
      field: "billNumber",
      headerName: "Bill Number",

      width: 150,
      renderCell: (params) => <span>{params.value || " -- "}</span>,
    },
    {

      field: "billDate",
      headerName: "Bill Date",
      width: 150,
      renderCell: (params) => {
        const value = params.value;

        if (!value) return <span>--</span>;

        // Try converting to Date object
        const date = new Date(value);

        // Check for invalid date
        if (isNaN(date.getTime())) return <span>--</span>;

        return <span>{date.toDateString()}</span>;
      }
    },



    {
      field: "view",
      headerName: "View",
      width: 250,
      renderCell: (params) => (
        <Button onClick={() => handleRowClick(params)}>
          Add/Edit billing details
        </Button>
      ),
    },
  ];

  return (
    <>
      <div className="flex space-x-6 py-6">
        {/* Task In Progress Card */}
        <div className="border border-gray-300 shadow p-6 rounded-lg text-center md:w-1/4 flex items-center gap-4 font-semibold">
          <h2 className="bg-[#FF8036] text-4xl text-white p-4 rounded-lg ">
            {inProgressCount}
          </h2>
          <p className="text-lg">Tasks In Progress</p>
        </div>

        {/* Tasks Completed Card */}
        <div className="border border-gray-300 shadow p-6 rounded-lg text-center md:w-1/4 flex items-center gap-4 font-semibold">
          <h2 className="bg-[#12B769] text-white p-4 rounded-lg text-4xl">
            {completedCount}
          </h2>
          <p className="text-lg">Tasks Completed</p>
        </div>
      </div>

      <SearchBar
        titleOne="ClientReport"
        onSearch={handleSearch}
      />



      {/* Data Table */}
      <div className="my-4">
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) => row._id || row.id}
          pageSizeOptions={[5, 8, 10, 25]}
          initialState={{ pagination: { paginationModel: { pageSize: 8, page: 0 } } }}
          checkboxSelection
          pagination
        />
      </div>

      {/* Modal to Add Billing Details */}
      <Modal
        title="Add Billing Details"
        open={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          setBillNumber("");
          setBillDate("");
        }}
        footer={null}
      >


        <div className="mb-4">
          <label htmlFor="billNumber" className="block mb-2">
            Bill Number
          </label>
          <Input
            id="billNumber"
            value={billNumber}
            onChange={(e) => {
              const numericValue = e.target.value.replace(/\D/g, ""); // remove non-digits
              setBillNumber(numericValue);
            }}
          />

        </div>
        <div className="mb-4">
          <label htmlFor="billDate" className="block mb-2">
            Bill Date
          </label>
          <DatePicker
      value={billDate}
      onChange={(date) => setBillDate(date)} // date is already a dayjs object
      style={{ width: "100%" }}
    />
        </div>
        <Button type="primary" onClick={handleSubmit}>
          Save
        </Button>

      </Modal>
    </>
  );
};

export default ClientReportHome;
